import React from "react";
import FiltersAreSelected from "../FiltersAreSelected";
import OutletFooter from "./OutletFooter";
import OutletHeader from "./OutletHeader";
import OutletShopPopularProducts from "./OutletShopPopularProducts";
import OutletShoppingFeatures from "./OutletShoppingFeatures";
import OutletWelcome from "./OutletWelcome";
import ProductListing from "../ProductListing";
import { OutletPageResult } from "./OutletPageResult";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";

const OutletPage = ({
  featureFlags,
  facetNavigation,
  mostPopularOutletCategories,
  mostRecentOutletProducts,
  pageName,
  pageUrl,
  pagination,
  popularCategories,
  products,
  searchTerm,
  showNoSearchResultsMessage,
  showOptoutMessage,
  showShoppingFeatures,
}: OutletPageResult) => {
  const showOutletShoppingFeatures =
    showShoppingFeatures && !FiltersAreSelected(facetNavigation);

  return (
    <div data-module="initOutletPage">
      <FeatureFlagProvider featureFlags={featureFlags}>
        {products?.length ? (
          <>
            <OutletWelcome showOptoutMessage={showOptoutMessage} />
            {showOutletShoppingFeatures && (
              <>
                <OutletShoppingFeatures
                  categoryFacets={facetNavigation.categoryFacets}
                  mostRecentOutletProducts={mostRecentOutletProducts}
                  popularCategories={popularCategories}
                />
                <OutletShopPopularProducts
                  popularProducts={mostPopularOutletCategories}
                />
              </>
            )}
            <ProductListing
              aboveChromeComponent={
                <OutletHeader
                  pageHeader={pageName}
                  {...{ searchTerm, showNoSearchResultsMessage }}
                />
              }
              belowPageComponent={<OutletFooter />}
              facetNavigation={facetNavigation}
              hasBackground={false}
              hasHeaderData={false}
              hideFilters={false}
              hideTopper
              pageName={pageName}
              pageUrl={pageUrl}
              pagination={pagination}
              products={products}
              showCategoryFilter
              showOutletConditionFilter
              showOutletPoliciesButton
              showPartsFilter={false}
            />
          </>
        ) : (
          <div className="container">
            <div className="page-header-container mt-8">
              <h1 className="page-header">No Results Found</h1>
            </div>
          </div>
        )}
      </FeatureFlagProvider>
    </div>
  );
};

export default OutletPage;
